module.exports = __webpack_public_path__ + "static/media/editGrey.61a39d0f.svg";